import './spaceSelect.scss';

import SpacesSocket from './socket/SpacesSocket';
import SpacesOnlineFriends from './components/Peoples/SpacesOnlineFriends';
import SpacesMessages from './components/Peoples/SpacesMessages';
import SpacesOneOnOne from './components/Peoples/SpacesOneOnOne';
import NewSpaceSelection from './components/Modals/Space/NewSpaceSelection';
import AuthRequiredModal from "./components/Modals/Space/AuthRequiredModal";
import FreeToPremiumSpaceModal from "./components/Modals/Space/FreeToPremiumSpaceModal";
import BuyNewPremiumSpacesModal from "./components/Modals/Space/BuyNewPremiumSpacesModal";
import SpaceUpgradeModal from "./components/Modals/Space/SpaceUpgradeModal";
import SpaceDowngradeModal from "./components/Modals/Space/SpaceDowngradeModal";
import { FEATURE_NAMES, UNLIMITED } from "./components/MVC/rolesHelper";

syncMobileMode();
let mobileModeTimer;
window.addEventListener('resize', () => {
  clearTimeout(mobileModeTimer);
  mobileModeTimer = setTimeout(syncMobileMode, 200);
});

$(() => {
  const authRequiredModal = new AuthRequiredModal({ /* model: ... */ });
  const newSpaceSelectionModal = new NewSpaceSelection({ /* model: ... */ });
  const freeToPremiumSpaceModal = new FreeToPremiumSpaceModal({
    subscriptionUrl: '/myprofile/subscriptions',
    planComparisonUrl: '/plans'
  });
  const buyNewPremiumSpacesModal = new BuyNewPremiumSpacesModal({
    subscriptionUrl: '/myprofile/subscriptions',
    planComparisonUrl: '/plans'
  });
  const spaceUpgradeModal = new SpaceUpgradeModal();
  const spaceDowngradeModal = new SpaceDowngradeModal();

  // Make FreeToPremiumSpaceModal globally available
  window.showFreeToPremiumSpaceModal = function () {
    freeToPremiumSpaceModal.show();
  };

  // Make BuyNewPremiumSpacesModal globally available
  window.showBuyNewPremiumSpacesModal = function () {
    buyNewPremiumSpacesModal.show();
  };

  // Show appropriate modal based on user subscription status
  window.showPremiumSpaceModal = function () {
    // Check if user has premium features available
    const hasPremiumFeatures = window?.subscriptionPlan?.plan?.id !== 1;
    if (!hasPremiumFeatures) {
      // User is on free plan - show upgrade modal
      window.showFreeToPremiumSpaceModal();
    } else {
      // User has premium plan but may be out of quota - show buy more modal
      window.showBuyNewPremiumSpacesModal();
    }
  };

  window.checkPlanAndCreatePremiumSpace = function (onAvailable = () => {}) {
    const createPremiumFeature = window.subscriptionPlan?.plan?.features?.[FEATURE_NAMES.CREATE_PREMIUM_SPACES];
    const maximumPremiumSpaces = window.subscriptionPlan?.customer.total_premium_spaces || 0;
    const usedPremiumSpaces = window.subscriptionPlan?.customer.used_premium_spaces || 0;
    if (!createPremiumFeature?.availability) {
      newSpaceSelectionModal.showUpgradeModal();
    } else if (maximumPremiumSpaces !== UNLIMITED && maximumPremiumSpaces <= usedPremiumSpaces) {
      newSpaceSelectionModal.showOutOfQuotaModal();
    } else {
      typeof onAvailable === 'function' && onAvailable();
    }
  };

  // Make PlanComparisonModal globally available
  window.showPlanComparisonModal = function (configs) {
    newSpaceSelectionModal.hideNotAvailableModal();
    newSpaceSelectionModal.hideMiniVersion();
    newSpaceSelectionModal.show(configs);
  }

  // Make SpaceUpgradeModal globally available
  window.showSpaceUpgradeModal = function (onConfirm = () => {}) {
    spaceUpgradeModal.show.bind(spaceUpgradeModal)(onConfirm);
  }

  // Make SpaceDowngradeModal globally available
  window.showSpaceDowngradeModal = function (onConfirm = () => {}) {
    spaceDowngradeModal.show.bind(spaceDowngradeModal)(onConfirm);
  }

  $('#auth-required-toggle').on('click', (e) => {
    e.preventDefault();
    authRequiredModal.show();
  })

  $('#create-space').on('click', (e) => {
    e.preventDefault();
    newSpaceSelectionModal.showMiniVersion();
  });

  $('body').on('click', '.space-select-modal__differences-question', (e) => {
    e.preventDefault();

    const $target = $(e.target);
    const configs = {
      showActions: $target.data('showActions') !== false, // default: true
    };

    showPlanComparisonModal(configs);
  })

  if (!window.isGuest && window.room_config && window.room_config.socketConfig) {
    const socket = new SpacesSocket(window.room_config.socketConfig);
    const friends = new SpacesOnlineFriends(window.room_config.socketConfig, socket);
    new SpacesMessages({
      socket,
      friends,
      config: window.room_config.socketConfig,
    });
    const calls = new SpacesOneOnOne({
      socket,
      friends,
      config: window.room_config.socketConfig,
    });
    friends.onVideoCall = (user) => calls.start(user);
    socket.connect();
  }
});

function syncMobileMode() {
  const mobile = isMobileDevice();
  const portrait = mobile && window.matchMedia('(orientation: portrait)').matches;
  document.body.classList.toggle('is-mobile-mode', mobile);
  document.body.classList.toggle('is-desktop-mode', !mobile);
  document.body.classList.toggle('is-portrait-mode', portrait);
  document.body.classList.toggle('is-landscape-mode', mobile && !portrait);
}

function isMobileDevice() {
  const agent = navigator.userAgent || navigator.vendor || '';
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Mobile/i.test(agent);
}

$(() => {
  $('.space-select-modal__differences-question').on('click', (e) => {
    e.preventDefault();

    const $target = $(e.target);
    const configs = {
      showActions: $target.data('showActions') !== false, // default: true
    };

    showPlanComparisonModal(configs);
  })
});
